<template>
	<div id="clickOutside"></div>
	<div class="flex items-center justify-between w-full gap-2 mb-4">
		<PageLabel :helpPageName="'Assessments' + tabName.replace(/\s+/g, '') + subTabName.replace(/\s+/g, '')"
			>{{ tabName + " - " + subTabName }}
		</PageLabel>

		<div class="flex flex-row items-center gap-2">
			<Button id="btnback" v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)" @click.stop="changePage('prev')"
				><!---:disabled="actualRawMaterialId === null"-->
				Back
			</Button>
			<Button
				id="btnSaveGeneralInformation"
				@click.prevent="saveDownstreamDistribution(true)"
				:disabled="progressSaving == true"
				v-bind="lock.button.value"
				v-tooltip="lock.tooltip"
			>
				Save
			</Button>
			<Button
				id="btnNext"
				v-if="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Read)"
				:disabled="actualRawMaterialId === null"
				@click.stop="changePage('next')"
			>
				Next
			</Button>
		</div>
	</div>
	<I2FormRow class="mt-6 mb-12">
		<I2FormField label="Type of Transport" helpElementName="TypeOfTransport">
			<Select
				v-model="selectedTypeOfTransport"
				:options="typeOfTransports"
				optionLabel="valueTxt"
				option-value="id"
				placeholder="Select type of Transport"
				class="w-full md:w-14rem"
				:class="{
					'p-invalid': (saveAttempted && selectedTypeOfTransport == null) || selectedTypeOfTransport == '',
					'': selectedTypeOfTransport !== null,
				}"
				@change="changeTOT(selectedTypeOfTransport)"
				v-bind="lock.select.value"
				v-tooltip="lock.tooltip"
				><!--@change="selectedCompOptionFilterOnDemand(compOpSelected)"-->
			</Select>
		</I2FormField>
		<I2FormField><div></div></I2FormField><I2FormField><div></div></I2FormField><I2FormField><div></div></I2FormField>
	</I2FormRow>
	<div>
		<DataTable
			:value="inboundTransportList"
			responsiveLayout="scroll"
			:row-hover="true"
			:paginator="false"
			:rows="tablePaginator == null ? 10 : tablePaginator.rows"
			:first="tablePaginator == null ? 0 : tablePaginator.first"
			:page="tablePaginator == null ? 0 : tablePaginator.page"
			@page="pageChanged($event)"
			paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
			:rowsPerPageOptions="[10, 20, 50]"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
			dataKey="id"
			:globalFilterFields="['materialName']"
			:id="'inboundTransportList_' + props.tabId"
			class="data-table"
			v-if="selectedTypeOfTransport !== null"
			:rowStyle="
				(data: any) => {
					// Apply colors only to Step rows (those with stepName containing 'Step')
					// but exclude the last row, add step row, and transport leg rows
					if (
						data &&
						data.stepName &&
						data.stepName.includes('Step') &&
						!data.stepName.includes('Add Step') &&
						!data.lastLine &&
						!data.isAddTransportLeg
					) {
						return {
							backgroundColor: 'var(--p-downstream-distribution-table-step-name-row-background-color, white)',
							color: 'var(--p-downstream-distribution-table-step-name-row-color, black)',
						}
					}
					return {}
				}
			"
		>
			<ColumnGroup type="header">
				<Row>
					<Column
						header=""
						:colspan="1"
						style="
							background-color: var(--p-downstream-distribution-table-step-field-background-color, white);
							color: var(--p-downstream-distribution-table-step-field-text-color, black);
						"
					/>
					<Column
						header="Transport"
						:colspan="3"
						style="
							background-color: var(--p-downstream-distribution-table-transport-group-background-color);
							color: var(--p-downstream-distribution-table-transport-group-text-color);
						"
					/>
					<Column
						header="Warehousing"
						:colspan="4"
						style="
							background-color: var(--p-downstream-distribution-table-wharehousing-group-background-color);
							color: var(--p-downstream-distribution-table-wharehousing-group-text-color);
						"
					/>
					<Column
						header=""
						:colspan="1"
						style="
							background-color: var(--p-downstream-distribution-table-action-field-background-color, white);
							color: var(--p-downstream-distribution-table-action-field-text-color, black);
						"
					/>
				</Row>
				<Row>
					<Column
						header="Step"
						:colspan="1"
						class="stepColor"
						style="
							background-color: var(--p-downstream-distribution-table-step-field-background-color);
							color: var(--p-downstream-distribution-table-step-field-text-color);
						"
					/>
					<Column
						header="Mode Of Transport"
						field="lastYearSale"
						style="
							background-color: var(--p-downstream-distribution-table-transport-group-background-color);
							color: var(--p-downstream-distribution-table-transport-group-text-color);
						"
					/>
					<Column
						header="Distance"
						field="thisYearSale"
						style="
							background-color: var(--p-downstream-distribution-table-transport-group-background-color);
							color: var(--p-downstream-distribution-table-transport-group-text-color);
						"
					/>
					<Column
						header="Unit"
						field="lastYearProfit"
						style="
							background-color: var(--p-downstream-distribution-table-transport-group-background-color);
							color: var(--p-downstream-distribution-table-transport-group-text-color);
						"
					/>
					<Column
						header="Temperature Requirements"
						field="thisYearProfit"
						style="
							background-color: var(--p-downstream-distribution-table-wharehousing-group-background-color);
							color: var(--p-downstream-distribution-table-wharehousing-group-text-color);
						"
					/>
					<Column
						header="Storage Time"
						field="lastYearSale"
						style="
							background-color: var(--p-downstream-distribution-table-wharehousing-group-background-color);
							color: var(--p-downstream-distribution-table-wharehousing-group-text-color);
						"
					/>
					<Column
						header="Unit"
						field="thisYearSale"
						style="
							background-color: var(--p-downstream-distribution-table-wharehousing-group-background-color);
							color: var(--p-downstream-distribution-table-wharehousing-group-text-color);
						"
					/>
					<Column
						header="Location"
						field="lastYearProfit"
						style="
							background-color: var(--p-downstream-distribution-table-wharehousing-group-background-color);
							color: var(--p-downstream-distribution-table-wharehousing-group-text-color);
						"
					/>
					<Column
						header="Actions"
						:colspan="1"
						style="
							background-color: var(--p-downstream-distribution-table-action-field-background-color);
							color: var(--p-downstream-distribution-table-action-field-text-color);
						"
					/>
				</Row>
			</ColumnGroup>
			<Column
				field="stepName"
				filterField="stepName"
				header="Step"
				:headerStyle="{
					backgroundColor: 'var(--p-downstream-distribution-table-step-field-background-color, black)',
					color: 'var(--p-downstream-distribution-table-step-field-text-color, white)',
				}"
			>
				<template #body="{ data, index }">
					<div v-if="!data.isTitle && !data.lastLine"></div>
					<div v-if="data.isTitle || data.lastLine">
						<!-- <InputText v-model.number="data.stepName" @change="changeStep(data)" style="width: 120px" v-if="data.isTitle" /> -->
						<b>{{ highlightLine(index) ? data.stepName : data.stepName }}</b>
					</div>
					<div v-if="data.lastLine && !data.isTitle">
						<div style="width: 140px">
							<span style="cursor: pointer" @click="!assessmentStore.isLocked && addLeg(data, index)"
								><FontAwesomeIcon
									:icon="['far', 'plus-circle']"
									title="Add Transport Leg"
									class="ml-2"
									v-show="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Update)"
								/><span class="ml-2">Add Step </span></span
							>
						</div>
					</div>
				</template>
			</Column>
			<Column
				field="modeOfTransport"
				filterField="modeOfTransport"
				header="Mode of Transport (Transport)"
				style="flex: 0 0 30%"
				:headerStyle="{ backgroundColor: 'green', color: 'white' }"
			>
				<template #header></template>
				<template #body="{ data, index }">
					<div v-if="!data.isTitle && !data.lastLine && !data.isAddTransportLeg">
						<Select
							v-model="data.modeOfTransportId"
							:options="modeOfTransports"
							optionLabel="transportName"
							option-value="id"
							filter
							placeholder="Select Transport"
							class="w-full md:w-14rem"
							:class="{ 'p-invalid': data.modeOfTransportId === null, '': data.modeOfTransportId !== null }"
							@change="changeDistribution(data)"
							v-bind="lock.select.value"
							v-tooltip="lock.tooltip"
						>
						</Select>
					</div>
					<div v-if="data.isAddTransportLeg">
						<span style="cursor: pointer" @click="!assessmentStore.isLocked && addLeg(data, index)"
							><FontAwesomeIcon
								:icon="['far', 'plus-circle']"
								title="Add Transport Leg"
								class="ml-2"
								v-show="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Update)"
								v-bind="lock.icon.value"
								v-tooltip="lock.tooltip"
							/><span class="ml-2">Add Transport Leg</span></span
						>
					</div>
				</template> </Column
			><Column
				field="distance"
				filterField="distance"
				header="Distance (Transport)"
				style="flex: 0 0 10%"
				:headerStyle="{ backgroundColor: 'green', color: 'white' }"
			>
				<template #body="{ data, index }">
					<div v-if="!data.isTitle && !data.lastLine && !data.isAddTransportLeg">
						<InputText
							v-model.number="data.distance"
							@keypress="onlyNumbers($event)"
							:class="{
								'p-invalid': data.distance === null || data.distance === 0 || data.distance === '',
								'': data.distance !== null,
							}"
							@change="changeDistribution(data)"
							style="width: 80px"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</div>
				</template> </Column
			><Column
				field="unit"
				filterField="unit"
				header="Unit (Transport)"
				style="flex: 0 0 30%"
				:headerStyle="{ backgroundColor: 'green', color: 'white' }"
			>
				<template #body="{ data, index }">
					<div v-if="!data.isTitle && !data.lastLine && !data.isAddTransportLeg">
						<Select
							v-model="data.unitId"
							:options="trasportUnits"
							optionLabel="unitName"
							option-value="id"
							filter
							placeholder="Select Unit"
							class="w-full md:w-14rem"
							:class="{ 'p-invalid': data.unitId === null, '': data.unitId !== null }"
							@change="changeDistribution(data)"
							v-bind="lock.select.value"
							v-tooltip="lock.tooltip"
						>
						</Select>
					</div>
				</template>
			</Column>
			<Column
				field="tempRequirement"
				filterField="tempRequirement"
				header="Temperature Requirements (Warehousing)"
				style="flex: 0 0 30%"
				:headerStyle="{ backgroundColor: 'pink', color: 'black' }"
			>
				<template #body="{ data, index }">
					<div v-if="!data.isTitle && !data.lastLine && !data.isAddTransportLeg">
						<Select
							v-model="data.tempRequirementId"
							:options="tempRequirements"
							optionLabel="temperatureRequirement"
							option-value="id"
							filter
							placeholder="Select Temperature Requirements"
							class="w-full md:w-14rem"
							:class="{ 'p-invalid': saveAttempted && data.modeOfTransportId === null, '': data.modeOfTransportId !== null }"
							@change="changeDistribution(data)"
							v-bind="lock.select.value"
							v-tooltip="lock.tooltip"
						>
						</Select>
					</div>
				</template> </Column
			><Column
				field="storageTime"
				filterField="storageTime"
				header="Storage Time (Warehousing)"
				style="flex: 0 0 30%"
				:headerStyle="{ backgroundColor: 'pink', color: 'black' }"
			>
				<template #body="{ data, index }">
					<div v-if="!data.isTitle && !data.lastLine && !data.isAddTransportLeg">
						<InputText
							v-model.number="data.storageTime"
							@keypress="onlyNumbers($event)"
							:class="{
								'p-invalid': saveAttempted && (data.storageTime === null || data.storageTime === 0 || data.storageTime === ''),
								'': data.modeOfTransportId !== null,
							}"
							@change="changeDistribution(data)"
							style="width: 80px"
							v-bind="lock.input.value"
							v-tooltip="lock.tooltip"
						/>
					</div>
				</template> </Column
			><Column
				field="storageTimeUnit"
				filterField="storageTimeUnit"
				header="Unit (Warehousing)"
				style="flex: 0 0 30%"
				:headerStyle="{ backgroundColor: 'pink', color: 'black' }"
			>
				<template #body="{ data, index }">
					<div v-if="!data.isTitle && !data.lastLine && !data.isAddTransportLeg">
						<Select
							v-model="data.storageTimeUnitId"
							:options="tempReqUnits"
							optionLabel="unitName"
							option-value="id"
							filter
							placeholder="Select Unit"
							class="w-full md:w-14rem"
							:class="{ 'p-invalid': saveAttempted && data.storageTimeUnitId === null, '': data.storageTimeUnitId !== null }"
							@change="changeDistribution(data)"
							v-bind="lock.select.value"
							v-tooltip="lock.tooltip"
							style="width: 130px"
						>
						</Select>
					</div>
				</template> </Column
			><Column
				field="location"
				filterField="location"
				header="Location (Warehousing)"
				style="flex: 0 0 30%"
				:headerStyle="{ backgroundColor: 'pink', color: 'black' }"
			>
				<template #body="{ data, index }">
					<div v-if="!data.isTitle && !data.lastLine && !data.isAddTransportLeg">
						<Select
							v-model="data.locationId"
							:options="siteLocations"
							optionLabel="siteLocationName"
							option-value="id"
							filter
							placeholder="Select Location"
							class="w-full md:w-14rem"
							:class="{ 'p-invalid': saveAttempted && data.locationId === null, '': data.locationId !== null }"
							@change="changeDistribution(data)"
							v-bind="lock.select.value"
							v-tooltip="lock.tooltip"
						>
						</Select>
					</div>
				</template> </Column
			><Column
				field="id"
				style="width: 5%"
				styleClass="tdLessPadding"
				header="Actions"
				:headerStyle="{
					backgroundColor: 'var(--p-downstream-distribution-table-action-field-background-color, blue)',
					color: 'var(--p-downstream-distribution-table-action-field-text-color, white)',
				}"
			>
				<template #body="{ data, index }"
					><span
						style="cursor: pointer"
						v-if="!data.isTitle && !data.lastLine && !data.isAddTransportLeg"
						@click="!assessmentStore.isLocked && removeAddedTransport(data, index)"
						><FontAwesomeIcon
							:icon="['far', 'trash']"
							title="Delete"
							class="ml-2"
							v-show="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Delete)" /></span></template
			></Column>
		</DataTable>
	</div>
	<Dialog :visible="dialogDefaultConfirmation" style="width: 20vw" modal :closable="false">
		<template #header>
			<div class="flex justify-between w-full">
				<h1>Apply default values?</h1>
				<div class="flex gap-2">
					<Button id="btnapply" type="Button" @click="dialogDefaultConfirmation = false" class="btn bg-redSignal">Cancel</Button>
					<Button
						id="btnSaveProject"
						class="btn btn-primary"
						v-show="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Create)"
						@click="applyDefaults()"
					>
						Apply
					</Button>
				</div>
			</div>
		</template></Dialog
	>
	<Dialog :visible="dialogDefaultConfirmationDeleteUserDefined" style="width: 50vw" modal :closable="false">
		<template #header>
			<div class="flex justify-between w-full">
				<h1>By proceeding you will loose your changes<br />do you want to proceed?</h1>
				<div class="flex gap-2">
					<Button id="btnapply" type="Button" @click="noChangeTypeOfTransport()">No</Button>
					<Button
						id="btnSaveProject"
						v-show="SessionInfo.hasRightsToScreen('Assessments', PageAccess.Create)"
						@click="actionSelectedTOT(selectedTypeOfTransport)"
					>
						Yes
					</Button>
				</div>
			</div>
		</template></Dialog
	>
</template>
<script setup lang="ts">
import { ref, onMounted, watchEffect, watch } from "vue"
import { SessionInfo, PageAccess } from "../auth/personSessionData"
import { EventBus } from "../eventBus"
import { useToast } from "primevue/usetoast"
import DataTable from "primevue/datatable"
import Column from "primevue/column"
import ColumnGroup from "primevue/columngroup"
import Row from "primevue/row"
import InputText from "primevue/inputtext"
import Select from "primevue/select"
import Button from "primevue/button"
import Dialog from "primevue/dialog"
import { ApiClient, DownstreamStep, DownstreamDistribution } from "../../entities/NSwagGenerated"
import { useHistoryHelper } from "../composables/historyHelper"
import { useAssessmentStore } from "@/store/assessmentStore"
import { useAssessmentLock } from "@/composables/assessmentLock"
const assessmentStore = useAssessmentStore()
const lock = useAssessmentLock(assessmentStore)
const apiClient = new ApiClient(import.meta.env.VITE_API_URL?.toString())
const toast = useToast()
const { updateAssessmentUpdatedByDate } = useHistoryHelper()

const props = defineProps({
	assessmentId: {
		type: String,
		required: true,
		default: "",
	},
	tabName: {
		type: String,
		required: true,
		default: "",
	},
	tabId: {
		type: String,
		required: true,
		default: "",
	},
	subTabName: {
		type: String,
		required: true,
		default: "",
	},
	allTabsInformation: {
		type: Object,
		required: true,
		default: "",
	},
})

function refreshResultsTabAvailability() {
	EventBus.emit("checkIfResultNeedToBeEnabled_" + props.tabId, props.assessmentId)
}
const progressSaving = ref(false)
const saveAttempted = ref(false)
let tablePaginator: any | null = null

//type of transports
const typeOfTransports = ref()
const selectedTypeOfTransport = ref(null)
//table
const modeOfTransports = ref()
const trasportUnits = ref()
const tempRequirements = ref()
const tempReqUnits = ref()
const siteLocations = ref()

const inboundTransportList = ref([])

const normalText = {
	stepId: "",
	downstreamStepId: "",
	stepName: "step",
	transportId: "",
	modeOfTransportId: "",
	distance: 1000,
	unitId: "",
	tempRequirementId: "",
	storageTime: 1001,
	storageTimeUnitId: "",
	locationId: "",
	isTitle: false,
	lastLine: false,
	isAddTransportLeg: false,
	isData: true,
}

const textLine = {
	stepId: "",
	downstreamStepId: "",
	stepName: "step s",
	transportId: "",
	modeOfTransportId: "",
	distance: 100011,
	unitId: "",
	tempRequirementId: "",
	storageTime: 1001,
	storageTimeUnitId: "",
	locationId: "",
	isTitle: true,
	lastLine: false,
	isAddTransportLeg: false,
	isData: false,
}

const addTransportLeg = {
	isTitle: false,
	lastLine: false,
	isAddTransportLeg: true,
	isData: false,
}
const lastLine = {
	isTitle: false,
	lastLine: true,
	isAddTransportLeg: false,
	isData: false,
}
// inboundTransportList.value.push(textLine)
// inboundTransportList.value.push(normalText)
// inboundTransportList.value.push(addTransportLeg)
//inboundTransportList.value.push(lastLine)

//TAB STATUS
class tabActualStatus {
	actualMainTabId: string
	actualSubTabName: string
	selectedStepId: string
	generalInformationId: string
}

class allTabsActualStatus {
	public allTabsStatus: tabActualStatus[]
}

//basic info
const selectedStepName = ref()
const actualStepId = ref()
const stepName = ref()
const stepNumber = ref()
const actualUnitOperationId = ref()
const actualGeneralInformation = ref()

//dialog
const dialogDefaultConfirmation = ref(false) //dialog to apply default values
const oldSelection = ref()
const isUserDefined = ref()
const dialogDefaultConfirmationDeleteUserDefined = ref(false)
onMounted(() => {
	EventBus.on("selectedStep_" + props.tabId, (data: any) => {
		selectedStepName.value = data.stepName
		actualStepId.value = data.id
		stepName.value = data.stepName
		stepNumber.value = data.stepNumber
		actualUnitOperationId.value = data.unitOperationId
		actualGeneralInformation.value = data.generalInformationId
	})
	EventBus.on("DownstreamDistributionUpdate" + props.tabId, () => {
		setBasicSettings()
		updateDistributionTable()
	})
})

const setBasicSettings = () => {
	actualStepId.value = props.allTabsInformation.allTabsStatus.find((item: any) => item.actualMainTabId === props.tabId).selectedStepId
	actualGeneralInformation.value = props.allTabsInformation.allTabsStatus.find(
		(item: any) => item.actualMainTabId === props.tabId
	).generalInformationId
}

function applyDefaults() {
	dialogDefaultConfirmation.value = false
	actionSelectedTOT(selectedTypeOfTransport.value)
}

function checkSelected() {}

function getDownstreamDistDistributionBasicInfo() {
	apiClient.getDownstreamDistDistributionBasicInfo(actualStepId.value).then((res) => {
		if (res !== null) {
			selectedTypeOfTransport.value = res.typeOfTransportId

			isUserDefined.value = res.typeOfTransport.valueTxt === "User defined"

			getDistributionTableContent()
		}
	})
}

function getDistributionTableContent() {
	inboundTransportList.value = []
	apiClient.getDownstreamDistDistribution(actualStepId.value).then((res) => {
		res.forEach((single, position) => {
			let stepLine = {
				stepId: single.stepId,
				downstreamStepId: single.id,
				stepName: single.downstreamStepName,
				transportId: "",
				modeOfTransportId: "",
				distance: null,
				unitId: "",
				tempRequirementId: "",
				storageTime: null,
				storageTimeUnitId: "",
				locationId: "",
				isTitle: true,
				lastLine: false,
				isAddTransportLeg: false,
				isData: false,
			}
			inboundTransportList.value.push(stepLine)
			single.downstreamDistribution?.forEach((element: any) => {
				let transportLine = {
					stepId: element.stepId,
					downstreamStepId: element.downstreamStepId,
					stepName: "",
					transportId: element.id,
					modeOfTransportId: element.modeOfTransport,
					distance: element.distance,
					unitId: element.modeOfTransportUnit,
					tempRequirementId: element.tempRequirements,
					storageTime: element.tempStorageTime,
					storageTimeUnitId: element.tempStorageTimeUnitId,
					locationId: element.tempStorageLocation,
					isTitle: false,
					lastLine: false,
					isAddTransportLeg: false,
					isData: true,
				}
				inboundTransportList.value.push(transportLine)
			})
			let addTransportLegs = {
				stepId: single.stepId,
				downstreamStepId: single.id,
				isTitle: false,
				lastLine: false,
				isAddTransportLeg: true,
				isData: false,
			}
			inboundTransportList.value.push(addTransportLegs)
		})
		refreshResultsTabAvailability()
		const lastLine = {
			isTitle: false,
			lastLine: true,
			isAddTransportLeg: false,
			isData: false,
		}
		inboundTransportList.value.push(lastLine)
	})
}

function updateDistributionTable() {
	inboundTransportList.value = []
	getRawMaterialsRelatedDropdowns().then((res) => {
		getDownstreamDistDistributionBasicInfo()
	})
}

// function updatTypeOfTransport(){

// 	apiClient.postDistributionDownstream(selectedTypeOfTransport.value,actualStepId.value).then((res)=>{

// 	})
// }

function changeStep(data: any) {
	var stepsteps = new DownstreamStep()
	stepsteps.id = data.downstreamStepId
	stepsteps.downstreamStepName = data.stepName
	stepsteps.isActive = true
	stepsteps.stepId = data.stepId
	apiClient.postDistributionStepFromTable(stepsteps).then((res) => {})
}
function changeDistribution(data: any) {
	isUserDefined.value = true
	var stepsteps = new DownstreamDistribution()
	stepsteps.id = data.transportId
	stepsteps.modeOfTransport = data.modeOfTransportId
	stepsteps.distance = data.distance
	stepsteps.modeOfTransportUnit = data.unitId
	stepsteps.tempRequirements = data.tempRequirementId
	stepsteps.tempStorageTime = data.storageTime
	stepsteps.tempStorageTimeUnitId = data.storageTimeUnitId
	stepsteps.tempStorageLocation = data.locationId

	stepsteps.isActive = true
	stepsteps.downstreamStepId = data.downstreamStepId
	apiClient.postDistributionTransportFromTable(stepsteps).then((res) => {
		selectedTypeOfTransport.value = typeOfTransports.value.find((x: any) => x.valueTxt == "User defined").id
		updateTypeOfTransport()
		refreshResultsTabAvailability()
	})
}

function addLeg(data: any, index: number) {
	let transportLine = {
		stepId: actualStepId.value,
		downstreamStepId: data.downstreamStepId,
		stepName: "",
		transportId: self.crypto.randomUUID(),
		modeOfTransportId: null,
		distance: null,
		unitId: null,
		tempRequirementId: null,
		storageTime: null,
		storageTimeUnitId: null,
		locationId: null,
		isTitle: false,
		lastLine: false,
		isAddTransportLeg: false,
		isData: true,
	}
	var stepID = self.crypto.randomUUID()

	let stepLine = {
		stepId: actualStepId.value,
		downstreamStepId: stepID,
		stepName: "Step " + (inboundTransportList.value.filter((x: any) => x.isTitle == true).length + 1),
		transportId: "",
		modeOfTransportId: "",
		distance: null,
		unitId: "",
		tempRequirementId: "",
		storageTime: null,
		storageTimeUnitId: "",
		locationId: "",
		isTitle: true,
		lastLine: false,
		isAddTransportLeg: false,
		isData: false,
	}
	let addTransportLegs = {
		stepId: actualStepId.value,
		downstreamStepId: stepID,
		isTitle: false,
		lastLine: false,
		isAddTransportLeg: true,
		isData: false,
	}
	if (data.lastLine) changeStep(stepLine)
	inboundTransportList.value.splice(index, 0, data.lastLine ? stepLine : transportLine)
	removeHighlightLine(index)
	removeHighlightLine(index + 1)
	if (data.lastLine) {
		inboundTransportList.value.splice(index + 1, 0, addTransportLegs)
		removeHighlightLine(index + 1)
	}
	//inboundTransportList.value.push(normalText)
}

function highlightLine(toHigthlight: number) {
	var numberOfLines = inboundTransportList.value.length
	setTimeout(() => {
		var rootElement = document.getElementById("inboundTransportList_" + props.tabId)

		if (rootElement) {
			var childElement = rootElement.querySelectorAll(".p-datatable-tbody")

			if (childElement.length > 0) {
				for (var i = 0; i < numberOfLines; i++) {
					if (i === toHigthlight) {
						// Check if this is a row that should get stepRow colors
						const rowData = inboundTransportList.value[i]

						// Apply colors only to Step rows, excluding "Add Step" rows
						if (
							rowData &&
							rowData.stepName &&
							rowData.stepName.includes("Step") &&
							!rowData.stepName.includes("Add Step") &&
							!rowData.lastLine &&
							!rowData.isAddTransportLeg
						) {
							childElement[0].children[i].style.backgroundColor = "var(--p-downstream-distribution-table-step-name-row-background-color)"
							childElement[0].children[i].style.color = "var(--p-downstream-distribution-table-step-name-row-color)"
						}
					}
				}
			} else {
			}
		}
	}, 250)
	return true
}
function removeHighlightLine(toHigthlight: number) {
	var numberOfLines = inboundTransportList.value.length
	setTimeout(() => {
		var rootElement = document.getElementById("inboundTransportList_" + props.tabId)

		if (rootElement) {
			var childElement = rootElement.querySelectorAll(".p-datatable-wrapper table .p-datatable-tbody")

			if (childElement.length > 0) {
				for (var i = 0; i < numberOfLines; i++) {
					if (i === toHigthlight) childElement[0].children[i].classList.remove("p-highlight")
				}
			} else {
			}
		}
	}, 250)
	return true
}

function updateTypeOfTransport() {
	if (selectedTypeOfTransport.value == null) return
	apiClient.postDistributionDownstream(selectedTypeOfTransport.value, actualStepId.value).then((res) => {})
}

function changeTOT(data: any) {
	if (isUserDefined.value) {
		dialogDefaultConfirmationDeleteUserDefined.value = true
	} else {
		actionSelectedTOT(data)
	}
}

function noChangeTypeOfTransport() {
	dialogDefaultConfirmationDeleteUserDefined.value = false
	selectedTypeOfTransport.value = typeOfTransports.value.find((x: any) => x.valueTxt == "User defined").id
}

function actionSelectedTOT(selectedTypeOfTransport: string) {
	dialogDefaultConfirmationDeleteUserDefined.value = false
	if (selectedTypeOfTransport == null) return
	apiClient.postDistributionDownstream(selectedTypeOfTransport, actualStepId.value).then((res) => {
		apiClient.getDownstreamDistDistributionDefaults(selectedTypeOfTransport, actualStepId.value).then((res) => {
			getDistributionTableContent()
		})
	})
}
function getRawMaterialsRelatedDropdowns(): Promise<string> {
	return new Promise((resolve, reject) => {
		apiClient.getDownstreamDistDropdowns().then(
			(res) => {
				modeOfTransports.value = res.modeOfTransport
				trasportUnits.value = res.transportUnit
				tempRequirements.value = res.tempRequirement
				tempReqUnits.value = res.tempReqUnit
				siteLocations.value = res.siteLocation
				typeOfTransports.value = res.typeOfTransport
				resolve("ok")
			},
			(err) => {
				reject(err)
			}
		)
	})
}

function removeAddedTransport(data: any, index: number) {
	apiClient.deleteDistributionTransportFromTable(data.transportId).then((res) => {
		if (res) {
			inboundTransportList.value.splice(index, 1)
			selectedTypeOfTransport.value = typeOfTransports.value.find((x: any) => x.valueTxt == "User defined").id
			updateTypeOfTransport()
			refreshResultsTabAvailability()
		}
	})
}

function changeTransport(type: string, event: any, index: number) {}

function onlyNumbers(evt: any) {
	evt = evt ? evt : window.event
	var charCode = evt.which ? evt.which : evt.keyCode
	if (
		(charCode != 46 || evt.target.value.indexOf(".") != -1) && // “.” CHECK DOT, AND ONLY ONE.
		(charCode < 48 || charCode > 57)
	) {
		evt.preventDefault()
		return false
	} else {
		return true
	}
}
function saveDownstreamDistribution(showToast: boolean) {
	var verifyIfEmpty = inboundTransportList.value.filter(
		(x: any) => (x.modeOfTransportId == null || x.distance == null || x.unitId == null) && x.isData
	)
	if (verifyIfEmpty.length > 0) {
		toast.add({
			severity: "error",
			summary: "Please fill all required fields",
			detail: ``,
			life: 3000,
			group: props.tabId,
		})
	} else {
		if (showToast)
			toast.add({
				severity: "success",
				summary: "Downstream distribution saved",
				detail: ``,
				life: 3000,
				group: props.tabId,
			})
		updateAssessmentUpdatedByDate(props.assessmentId)
	}
}
//emitting event for page status checks when user click next prev
function changePage(action: string) {
	EventBus.emit("nextPreviousTab_" + props.tabId, { action: action, actualTab: props.tabId })
}
//material datatable functions
function pageChanged(ev: Event) {
	tablePaginator = ev
	localStorage.setItem("projectListPaginate", JSON.stringify(ev))
}
</script>
<style lang="scss" scoped>
.headerPersonalizzato {
	background-color: red;
	color: white;
}

.data-table {
	width: 100%;
	border-collapse: collapse;
}

.data-table th {
	background-color: #f4f4f4;
	border: 1px solid #ddd;
	padding: 8px;
	text-align: left;
}

.data-table th[colspan] {
	text-align: center;
}

.data-table td {
	border: 1px solid #ddd;
	padding: 8px;
	text-align: left;
}

.data-table th[rowspan] {
	text-align: center;
	vertical-align: middle;
}
.btn-outline {
	background-color: white;
	color: #007bff;
	border: 2px solid #007bff;
	padding: 5px 10px;
	font-size: 12px;
	border-radius: 3px;
	cursor: pointer;
	transition: all 0.3s ease;
}

.btn-custom:hover {
	background-color: #007bff;
	color: white;
}
</style>
